import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";
import { EditorToolbar } from "../editor/EditorToolbar";
import { MonacoEditor } from "../editor/MonacoEditor";
import { BottomPanel } from "../editor/BottomPanel";

export function CenterPanel() {
    return (
        <div className="h-full flex flex-col relative">
            <PanelGroup direction="vertical" className="flex-1">
                {/* Top: Editor */}
                <Panel id="editor-panel" order={1} defaultSize={50} minSize={15}>
                    <div className="h-full flex flex-col">
                        <EditorToolbar />
                        <div className="flex-1 relative">
                            <MonacoEditor />
                        </div>
                    </div>
                </Panel>

                <PanelResizeHandle className="h-[3px] bg-[#181818] hover:bg-[#0078d4]/30 transition-colors duration-150 relative group">
                    <div className="absolute left-1/2 -translate-x-1/2 top-0 h-full flex gap-0.5 items-center opacity-0 group-hover:opacity-100 transition-opacity">
                        <div className="h-0.5 w-1 rounded-full bg-[#0078d4]/50" />
                        <div className="h-0.5 w-1 rounded-full bg-[#0078d4]/50" />
                        <div className="h-0.5 w-1 rounded-full bg-[#0078d4]/50" />
                    </div>
                </PanelResizeHandle>

                {/* Bottom: Diagram / Plot / DSP UI / GUI Builder */}
                <Panel id="bottom-panel" order={2} defaultSize={50} minSize={20}>
                    <BottomPanel />
                </Panel>
            </PanelGroup>
        </div>
    );
}
